import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// const menuButton = document.getElementById('js-menu-button');
// const closeButton = document.querySelectorAll('.js-close-menu-button');
// const globalMenu = document.getElementById('js-nav');

const header = document.getElementById('ansys-header');
const nav = document.getElementById('js-nav');
const closeLayer = document.getElementById('js-close-nav-layer');
const STICKY_CLASS = 'is-sticky';
const OPEN_CLASS = 'is-open';


const changeHeader = () => {
  gsap.to(header, {
    scrollTrigger: {
      trigger: '.js-change-header',
      start: 'top top',
      onEnter() {
        header.classList.add(STICKY_CLASS);
        gsap.to('#header-logo', {
          y: '-120%'
        });
        gsap.to('#header-logo-fixed', {
          y: 0
        });
      },
      onLeaveBack() {
        header.classList.remove(STICKY_CLASS);
        gsap.to('#header-logo', {
          y: 0
        });
        gsap.to('#header-logo-fixed', {
          y: '120%'
        });
      }
    }
  });
};

const openSubNavContent = () => {
  const buttons = document.querySelectorAll('.js-open-nav-content');

  buttons.forEach(button => {
    button.addEventListener('click', e => {
      const target = document.getElementById(e.currentTarget.getAttribute('data-target'));

      target.classList.add(OPEN_CLASS);
    });
  });
};

const closeSubNavContent = () => {
  const buttons = document.querySelectorAll('.js-nav-content-back');

  buttons.forEach(button => {

    button.addEventListener('click', () => {
      const target = button.closest('.l-navContentSub');
      target.classList.remove(OPEN_CLASS);
    });
  });
};

const openMenu = () => {
  const button = document.getElementById('js-menu-button-open');

  button.addEventListener('click', () => {
    nav.classList.add(OPEN_CLASS);

    gsap.set(closeLayer, {
      autoAlpha: 1,
    });
  });
};

const closeMenu = () => {
  const buttons = document.querySelectorAll('.js-close-menu');
  const navContentSubList = document.querySelectorAll('.l-navContentSub');

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      nav.classList.remove(OPEN_CLASS);

      navContentSubList.forEach(element => {
        element.classList.remove(OPEN_CLASS);
      });

      gsap.set(closeLayer, {
        autoAlpha: 0,
      });
    });
  });

};

export default () => {
  changeHeader();
  openMenu();
  closeMenu();
  openSubNavContent();
  closeSubNavContent();
};
